export default __webpack_public_path__ + "static/jenkins-5dcfabc14d96d555dbf2067b0c5fc4c5.jpg";